var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popper-wrapper" },
    [
      _vm.popupText
        ? _c(
            "popper",
            { attrs: { trigger: _vm.trigger, options: _vm.options } },
            [
              _c(
                "div",
                { staticClass: "popper", class: _vm.popperClasses },
                [
                  _vm.popupText.title
                    ? [
                        _c("div", { staticClass: "popper__heading" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.popupText.title) +
                              "\n        "
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.popupText.content
                    ? [
                        _c("div", { staticClass: "popper__body" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.popupText.content) +
                              "\n        "
                          )
                        ])
                      ]
                    : [
                        _vm._v(
                          "\n        " + _vm._s(_vm.popupText) + "\n      "
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c("template", { slot: "reference" }, [_vm._t("reference")], 2)
            ],
            2
          )
        : _vm._t("reference")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }